// eslint-disable-next-line import/no-extraneous-dependencies
import { isShutDown, getShutdownWindow } from 'shared/utils/featureFlags';

export { isShutDown, getShutdownWindow };
